import { useMutation } from '@tanstack/react-query';

import type { CreateEmployeeEmploymentWageArgs } from '../../../Domain/Employees/Services/EmployeeService';
import { employeeService } from '../../../Domain/Employees/Services/EmployeeService';

const mutationFn = (data: CreateEmployeeEmploymentWageArgs) => {
  return employeeService.createEmployeeEmploymentWage(data);
};

export const useEmployeeCreateEmploymentWageMutation = () => {
  return useMutation<unknown, unknown, CreateEmployeeEmploymentWageArgs>(mutationFn);
};
